import { Phone } from "lucide-react";
import { CartaoDados } from "./CartaoDados";
import { LinhaEditavel } from "./LinhaEditavel";
import { formatPhone, mascara, soDigitos } from "./formatos";
import type { SecaoProps } from "./tipos";
import { useCamposDaFicha } from "./use-campos-da-ficha";

const telefone = { formatDisplay: formatPhone, maskInput: mascara(formatPhone, 11), normalize: soDigitos, inputMode: "tel" as const };

export function SecaoContato({ patient, salvar, somenteLeitura }: SecaoProps) {
  const comum = { somenteLeitura };
  const { ver, obrigatorio } = useCamposDaFicha();
  return (
    <CartaoDados icon={Phone} titulo="Contato" subtitulo="Canais de comunicação" tom="ciano">
      {ver("phone") && (
      <LinhaEditavel {...comum} {...telefone} obrigatorio={obrigatorio("phone")} label="Celular" value={patient.phone ?? ""} placeholder="(11) 98765-4321" onSave={salvar.digitos("phone", "Celular")} />
      )}
      {ver("whatsapp") && (
      <LinhaEditavel
        {...comum}
        {...telefone}
        obrigatorio={obrigatorio("whatsapp")}
        label="WhatsApp"
        value={patient.whatsapp ?? ""}
        placeholder="Só se for outro número"
        vazio={patient.phone ? "Mesmo do celular" : undefined}
        onSave={salvar.digitos("whatsapp", "WhatsApp")}
      />
      )}
      {ver("landline") && (
      <LinhaEditavel
        {...comum}
        {...telefone}
        obrigatorio={obrigatorio("landline")}
        maskInput={mascara(formatPhone, 10)}
        label="Telefone fixo"
        value={patient.landline ?? ""}
        placeholder="(11) 3456-7890"
        onSave={salvar.digitos("landline", "Telefone fixo")}
      />
      )}
      {ver("email") && (
      <LinhaEditavel {...comum} obrigatorio={obrigatorio("email")} label="E-mail" value={patient.email ?? ""} inputMode="email" onSave={salvar.texto("email", "E-mail")} />
      )}
      {ver("contatoDeEmergencia") && (
      <>
      <LinhaEditavel
        {...comum}
        obrigatorio={obrigatorio("contatoDeEmergencia")}
        label="Contato de emergência"
        value={patient.contatoDeEmergenciaNome ?? ""}
        placeholder="Nome e parentesco"
        maxLength={120}
        onSave={salvar.texto("contatoDeEmergenciaNome", "Contato de emergência")}
      />
      <LinhaEditavel
        {...comum}
        {...telefone}
        obrigatorio={obrigatorio("contatoDeEmergencia")}
        label="Telefone de emergência"
        value={patient.contatoDeEmergenciaTelefone ?? ""}
        onSave={salvar.digitos("contatoDeEmergenciaTelefone", "Telefone de emergência")}
      />
      </>
      )}
    </CartaoDados>
  );
}
